import React from "react";
import "./UserEmailTable.css";
import CreditTable from "../CreditTable/CreditTable";

// Results of "Tüm Kullanıcı E-postaları". Each row can fetch that user's
// credits (Get Credit) or reset the password; the fetched credits expand
// inline underneath the matching row via CreditTable.
function UserEmailTable({
  emailData = [],
  selectedEmail,
  displayCreditData,
  creditData = [],
  loading,
  onGetCredit,
  onResetPassword,
  onUpdateStatus,
  onRefund,
}) {
  return (
    <div className="user-email-table-wrapper">
      <table className="user-email-table">
        <thead className="user-email-table-head">
          <tr>
            <th>İsim</th>
            <th>Soyisim</th>
            <th>E-posta</th>
            <th>Eski E-posta</th>
            <th className="user-email-actions-col">İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {emailData.length === 0 ? (
            <tr>
              <td className="user-email-empty" colSpan={5}>
                Kullanıcı bulunamadı.
              </td>
            </tr>
          ) : (
            emailData.map((item, index) => (
              <React.Fragment key={item.Id || index}>
                <tr className="user-email-row">
                  <td>{item.Name}</td>
                  <td>{item.Surname}</td>
                  <td className="user-email-cell-email">{item.Email}</td>
                  <td>{item.OldEmail || "-"}</td>
                  <td className="user-email-actions-col">
                    <div className="user-email-row-actions">
                      <button
                        type="button"
                        className="credit-btn credit-btn-primary"
                        onClick={() => onGetCredit && onGetCredit(item.Email)}
                      >
                        Kredileri Getir
                      </button>
                      <button
                        type="button"
                        className="credit-btn credit-btn-secondary"
                        onClick={() => onResetPassword && onResetPassword(item.Id)}
                      >
                        Şifre Sıfırla
                      </button>
                    </div>
                  </td>
                </tr>
                {displayCreditData && selectedEmail === item.Email && (
                  <tr className="user-email-expanded-row">
                    <td colSpan={5}>
                      <div className="user-email-expanded">
                        <CreditTable
                          data={creditData}
                          loading={loading}
                          onUpdateStatus={onUpdateStatus}
                          onRefund={onRefund}
                          emptyText="Bu kullanıcı için kredi bulunamadı."
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default UserEmailTable;
